import { render, staticRenderFns } from "./banner_detail.vue?vue&type=template&id=10bf4384&scoped=true"
import script from "./banner_detail.vue?vue&type=script&lang=ts"
export * from "./banner_detail.vue?vue&type=script&lang=ts"
import style0 from "./banner_detail.vue?vue&type=style&index=0&id=10bf4384&prod&lang=less&scoped=true"
import style1 from "./banner_detail.vue?vue&type=style&index=1&id=10bf4384&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf4384",
  null
  
)

export default component.exports